module.exports = __webpack_public_path__ + "static/1.4_the_tools_of_history-da55cc67ea5f481e6f6eb9834adb42f7.pdf";